<i18n>
{
  "fr": {
    "luggage": "Bagages",
    "luggage_possible_supplement": "Bagages supplémentaires possible",
    "luggage_included_no_w": "Aucun bagages inclus.|{q} bagage inclus par passager.|{q} bagages inclus par passager.",
    "luggage_included": "Aucun bagages inclus.|{q} bagage de {w}kg inclus par passager.|{q} bagages, max {w}kg inclus par passager.",
    "outward": "Aller",
    "return": "Retour"
  },
  "en": {
    "luggage": "Luggage",
    "luggage_possible_supplement": "Additional luggage possible",
    "luggage_included_no_w": "No luggage included.|{q} luggage included per passenger.|{q} luggage included per passenger.",
    "luggage_included": "No luggage included.|{q} luggage of {w}kg included per passenger.|{q} luggage of {w}kg included per passenger.",
    "outward": "Outward",
    "return": "Return"
  }
}
</i18n>

<template>
  <div class="pt-4">
    <div class="d-flex">
      <span>{{ $t('luggage') }} :</span>
      <v-spacer />
      <v-tooltip
        v-if="priceIncludedLuggage === 'UNDEFINED'"
        bottom
      >
        <template #activator="{ on, attrs }">
          <span
            v-bind="attrs"
            v-on="on"
          >
            <v-badge
              class="mr-2"
              color="none"
              icon="mdi-plus-circle"
              offset-x="10"
              offset-y="12"
              overlap
            >
              <template #badge>
                <v-icon
                  color="grey"
                >
                  mdi-plus-circle
                </v-icon>
              </template>
              <v-icon
                color="grey"
                small
              >
                mdi-bag-checked
              </v-icon>
            </v-badge>
          </span>
        </template>
        <span>
          {{ $t('luggage_possible_supplement') }}
        </span>
      </v-tooltip>
    </div>
    <ul class="pt-1">
      <li>
        <span class="caption">{{ $t('outward') }} : {{ computeLuggageSentence(pp.option_details[0]) }}</span>
      </li>
      <li v-if="pp.option_details[1]">
        <span class="caption">{{ $t('return') }} : {{ computeLuggageSentence(pp.option_details[1]) }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'DetailsCardLuggages',
  props: {
    pp: {
      type: Object,
      required: true
    },
    priceIncludedLuggage: {
      type: String,
      required: true
    }
  },
  methods: {
    /**
     * Return a sentence about the luggage quantity
     * @return string
     */
    computeLuggageSentence (details) {
      if (details.details[0].included_luggage) {
        if (details.details[0].included_luggage.weight === 0) {
          return this.$tc('luggage_included_no_w', details.details[0].included_luggage.bag_quantity, {
            q: details.details[0].included_luggage.bag_quantity
          })
        } else {
          /*
          return this.$tc('luggage_included', details.details[0].included_luggage.bag_quantity, {
            q: details.details[0].included_luggage.bag_quantity,
            w: details.details[0].included_luggage.weight
          })
          */
          return this.$tc('luggage_included_no_w', details.details[0].included_luggage.bag_quantity, {
            q: details.details[0].included_luggage.bag_quantity,
            w: details.details[0].included_luggage.weight
          })
        }
      }
      return this.$tc('luggage_included', 0, {
        q: 0,
        w: 0
      })
    }
  }
}
</script>

<style scoped>

/* Disable cursor pointer on tooltip */
[role=button] {
  cursor: default;
}

</style>
